import * as React from "react" 

class Preloader extends React.Component {
  componentDidMount() {
    document.querySelector('.preloader').classList.add('is-inview');
    setTimeout(function(){ document.querySelector('.preloader').classList.add('fade-out'); }, 1500);
  }

 

  render() {
    if(this.props.location !=="home") {
      return (
        <div className="preloader flex"></div>
      )
    } else {
      return (
        <div className="preloader"></div>
      )
    }
  }
} 

export default Preloader

 